const successMsgs = {
  changePassword: "تم تغيير كلمة المرور بنجاح",
  forgetPassword: "تم ارسال كلمة المرور جديدة",
  deletedSuccessfully: "تم الحذف",
  addedSuccessfully: "تم الاضافة بنجاح",
  editedSuccessfully: "تم التعديل بنجاح",
  generatedSuccessfully: "تم التعيين بنجاح",
  copiedSuccessfully: "تم النسخ بنجاح",
  cancelledSuccessfully: "تم الإلغاء بنجاح",
  settledSuccessfully:"تم التسوية بنجاح",
  blockedSuccessfully: "تم حظر العميل بنجاح",
  unblockedSuccessfully: "تم رفع حظر العميل بنجاح",
  resolvedSuccessfully: " حل بنجاح",
  exportTransactions: "تم ارسال ايميل تقرير معاملات الدفع",
  exportSettlements: "تم ارسال ايميل تقرير التسويات",
  exportSingleSettlement: "تم ارسال ايميل تقرير عناصر التسويات"
};

export default successMsgs;
